module.exports = __webpack_public_path__ + "static/media/emoji5.3ca0d7e3.png";